const FeaturedCard = ({ title, desc, extraClassName }) => {
    return (
        <div className={`fireknife-featured-card${extraClassName ? ` ${extraClassName}` : ''}`}>
            <div className="fireknife-featured-card__title">{title}</div>
            <div className={`fireknife-featured-card__desc`}>{desc}</div>
        </div>
    );
};

export default FeaturedCard;
